import { graphql } from 'react-apollo';

import { AllPossibleTransitions } from '../../../../queries/AllPossibleTransitions';

const createOptions = allPossibleTransitions =>
  allPossibleTransitions.map(state => ({
    key: state,
    value: state,
    text: state
  })) || [];

const withPossibleTransitionsQuery = graphql(AllPossibleTransitions, {
  options: ({ id }) => ({
    variables: {
      claimId: id
    },
    fetchPolicy: 'cache-first'
  }),
  props: ({ data: { allPossibleTransitions, loading, refetch } }) => ({
    loading,
    refetchTransitions: refetch,
    stateTransitionOptions: allPossibleTransitions
      ? createOptions(allPossibleTransitions)
      : []
  })
});

export default withPossibleTransitionsQuery;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/StateTransition/withPossibleTransitionsQuery.js